import {
  pgTable,
  uuid,
  text,
  integer,
  boolean,
  numeric,
  timestamp,
  index,
} from "drizzle-orm/pg-core";
import { orders } from "./orders.js";
import { products } from "./products.js";
import { inventoryLocations } from "./inventory-locations.js";

export const orderItems = pgTable(
  "order_items",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    orderId: uuid("order_id")
      .notNull()
      .references(() => orders.id, { onDelete: "cascade" }),
    productId: uuid("product_id").references(() => products.id, { onDelete: "set null" }),
    sku: text("sku").notNull(),
    name: text("name").notNull(),
    qty: integer("qty").notNull(),
    unitPrice: numeric("unit_price", { precision: 12, scale: 2 }).notNull(),
    lineTotal: numeric("line_total", { precision: 12, scale: 2 }).notNull(),
    requiresDeposit: boolean("requires_deposit").notNull().default(false),
    depositUnit: numeric("deposit_unit", { precision: 12, scale: 2 })
      .notNull()
      .default("0"),
    depositLineTotal: numeric("deposit_line_total", { precision: 12, scale: 2 })
      .notNull()
      .default("0"),
    fulfilledFromLocationId: uuid("fulfilled_from_location_id").references(
      () => inventoryLocations.id
    ),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    orderIdx: index("order_items_order_id_idx").on(t.orderId),
    productIdx: index("order_items_product_id_idx").on(t.productId),
  })
);

export type OrderItem = typeof orderItems.$inferSelect;
export type NewOrderItem = typeof orderItems.$inferInsert;
